export const AdminBillingRoute = '/settings/admin/billing';
export const AdminOverviewRoute = '/settings/admin/overview';
export const ConvertFreeTrialRoute = `${AdminBillingRoute}/convertfreetrial`;
export const DashboardRoute = '/dashboard';
export const EditBillingInfoRoute = `${AdminBillingRoute}/editbillinginfo`;
export const ExpirationRoute = '/expiration';
export const ExpirationPurchaseRoute = `${ExpirationRoute}/purchase`;
export const ManagePlanRoute = `${AdminBillingRoute}/manageplan`;
export const ReactivateRoute = `${AdminBillingRoute}/reactivate`;
export const ReceiptsRoute = `${AdminBillingRoute}/viewreceipts`;
